import { environment } from 'src/environments/environment.dev';
import { HttpServiceBase } from 'src/app/core/services/http.service';
import { Injectable } from '@angular/core';
import { Failure } from 'src/app/core/utils/failure';
import { LocalStorageServiceBase } from 'src/app/core/services/localStorage-serviceBase';
import { HttpHeaders } from '@angular/common/http';
import { ClaimMultiEntity } from '../../domain/entities/claim-multi.entity';
import { ClaimsPaginationParams } from '../../domain/entities/claim-pagination-params.entity';
import { MultiPagination } from '../../domain/entities/multi-pagination.entity';
import { UpdateClaimConciliatorEntity } from '../../domain/entities/update-claim-conciliator.entity';
import { UpdateClaimStatusEntity } from '../../domain/entities/update-claim-satus.entity';
import { DeleteClaimEntity } from '../../domain/entities/delete-claim.entity';
import { ClaimMultiModel } from '../models/claim-multi.model';
import { GetFileEntity } from '../../domain/entities/get-file.entity';

export abstract class ClaimMultiRemoteDataSourceBase {
  abstract getClaim(id: string): Promise<ClaimMultiEntity | Failure>;
  abstract updateClaim(claim: ClaimMultiEntity): Promise<string | Failure>;
  abstract createClaim(claim: ClaimMultiEntity): Promise<string | Failure>;
  abstract getMultiClaims(
    params: ClaimsPaginationParams
  ): Promise<MultiPagination | Failure>;
  abstract getAllFinishedClaims(
    params: ClaimsPaginationParams
  ): Promise<MultiPagination | Failure>;
  abstract updateClaimConciliator(
    claim: UpdateClaimConciliatorEntity
  ): Promise<string | Failure>;
  abstract getFile(params: GetFileEntity): Promise<string | Failure>;
  abstract updateClaimStatus(
    claim: UpdateClaimStatusEntity
  ): Promise<string | Failure>;
  abstract deleteClaim(
    deleteClaim: DeleteClaimEntity
  ): Promise<string | Failure>;
}

@Injectable()
export class ClaimMultiRemoteDataSource extends ClaimMultiRemoteDataSourceBase {
  private url: string = `${environment.apiUrl}/claimpluriindividual`;

  constructor(
    private httpService: HttpServiceBase,
    private localStorageService: LocalStorageServiceBase
  ) {
    super();
  }
  override async getClaim(id: string): Promise<ClaimMultiEntity> {
    let headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${this.localStorageService.read('access_token')}`
    );
    let result = await this.httpService.get(
      `${this.url}/get_claim_plurindivual_by_id?id=${id}`,
      headers
    );
    let response = result.get('response');
    let entries = Object.entries(response);
    let map = new Map<string, any>(entries);
    return ClaimMultiModel.fromJson(map);
  }

  override async createClaim(
    claim: ClaimMultiEntity
  ): Promise<string | Failure> {
    let headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${this.localStorageService.read('access_token')}`
    );
    let result = await this.httpService.post(`${this.url}`, claim, headers);
    return result.get('response');
  }

  override async updateClaim(
    claim: ClaimMultiEntity
  ): Promise<string | Failure> {
    let headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${this.localStorageService.read('access_token')}`
    );
    let result = await this.httpService.put(
      `${this.url}/update_claim_plurindividual?id=${claim.id}`,
      claim,
      headers
    );
    return result.get('response');
  }

  override async getMultiClaims(
    params: ClaimsPaginationParams
  ): Promise<MultiPagination | Failure> {
    let headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${this.localStorageService.read('access_token')}`
    );
    let result = await this.httpService.get(
      `${this.url}/get_all_claims_plurindivual${params.getPath()}`,
      headers
    );
    let response = result.get('response');
    return response;
  }

  override async getAllFinishedClaims(
    params: ClaimsPaginationParams
  ): Promise<MultiPagination | Failure> {
    let headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${this.localStorageService.read('access_token')}`
    );
    let result = await this.httpService.get(
      `${this.url}/get_all_claims_plurindividual_finished${params.getPath()}`,
      headers
    );
    let response = result.get('response');
    return response;
  }

  override async updateClaimConciliator(
    claim: UpdateClaimConciliatorEntity
  ): Promise<string | Failure> {
    let headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${this.localStorageService.read('access_token')}`
    );
    let result = await this.httpService.put(
      `${this.url}/change_conciliator_claim_plurindividual`,
      claim,
      headers
    );
    return result.get('response');
  }

  override async updateClaimStatus(
    claim: UpdateClaimStatusEntity
  ): Promise<string | Failure> {
    let headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${this.localStorageService.read('access_token')}`
    );
    let result = await this.httpService.put(
      `${this.url}/update_status_plurindividual?id=${claim.claimId}`,
      claim,
      headers
    );
    return result.get('response');
  }

  override async deleteClaim(
    deleteClaim: DeleteClaimEntity
  ): Promise<string | Failure> {
    let headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${this.localStorageService.read('access_token')}`
    );
    let result = await this.httpService.delete(
      `${this.url}/delete_claim_plurindividual`,
      deleteClaim,
      headers
    );
    return result.get('response');
  }

  override async getFile(params: GetFileEntity): Promise<string | Failure> {
    let headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${this.localStorageService.read('access_token')}`
    );
    let result = await this.httpService.get(
      `${this.url}/get_file_as_base64_plurindividual${params.getPath()}`,
      headers
    );
    return result.get('response');
  }
}
